import { useState } from "react";

export const TextConcat = ({ text, maxLength, isLink = false }) => {
    const [expanded, setExpanded] = useState(false);

    const safeText = typeof text === 'string' ? text : String(text || '');

    const displayText = expanded ? safeText : `${safeText.slice(0, maxLength)}...`;

    return (
        <div
            className="text-concat-wrapper"
            style={{
                wordBreak: "break-word",
                whiteSpace: "normal",
                overflowWrap: "break-word",
                maxWidth: "100%",
            }}
        >
            {(text && (text?.length > maxLength)) ? (
                <>
                    {isLink ? (
                        <a href={text} target="_blank" rel="noopener noreferrer">
                            {displayText}
                        </a>
                    ) : (
                        <span>{displayText}</span>
                    )}
                    <button
                        style={{
                            border: 'none',
                            background: 'none',
                            color: '#1890ff',
                            cursor: 'pointer',
                            marginLeft: '8px',
                        }}
                        onClick={() => setExpanded(!expanded)}
                    >
                        {expanded ? 'See less' : 'See more'}
                    </button>
                </>
            ) : (
                isLink ? (
                    <a href={text} target="_blank" rel="noopener noreferrer">
                        {text}
                    </a>
                ) : (
                    <span>{text}</span>
                )
            )}
        </div>
    )
}